// extracted by mini-css-extract-plugin
export var animationContainer = "_ht-0";
export var asteriskIcon = "_ht-8";
export var conversationLeftSection = "_ht-4";
export var conversationListItem = "_ht-3";
export var conversationMiddleSection = "_ht-5";
export var conversationRightSection = "_ht-6";
export var detailsContent = "_ht-1";
export var listContainer = "_ht-7";
export var modalContent = "_ht-2";